module.exports = __webpack_public_path__ + "static/SO_AMBITIOUS-120333cab45dbf111b2d63f288c76280.mp4";